<template>
    <div>
        <div
            class="modal fade"
            id="exampleModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModal">Concurso</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group row centrado">
                            <div v-if="!confirmLoading" class="col-md-12 m-3">
                                <span>
                                    Si desea crear un nuevo concurso debe
                                    colocar un nombre, en caso de querer una
                                    nueva version del actual deje el campo en
                                    blanco.</span
                                >
                            </div>
                            <label
                                v-if="!confirmLoading"
                                class="col-md-3 form-control-label"
                                for="text-input"
                                >Nombre</label
                            >
                            <div v-if="!confirmLoading" class="col-md-9">
                                <input
                                    type="text"
                                    v-model="new_name"
                                    class="form-control"
                                    placeholder="nombre"
                                />
                                <span
                                    v-if="allerrors.new_name"
                                    :class="['show-error']"
                                    >{{ allerrors.new_name[0] }}</span
                                >
                            </div>
                            <div v-if="confirmLoading" class="centrado">
                                <div class="lds-ring">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-primary"
                            @click="clone"
                        >
                            Clonar
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <form method="post" enctype="multipart/form-data">
            <div class="mt-3">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="card">
                            <div class="card-header font-weight-bold">
                                Datos Base Concurso
                            </div>
                            <div class="card-body">
                                <div
                                    class="row row-cols-1 row-cols-md-2 row-cols-lg-4"
                                >
                                    <span>
                                        <div class="form-group col">
                                            <label for="title"
                                                >ID Concurso
                                                <span class="text-danger"
                                                    >*</span
                                                ></label
                                            >
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="title"
                                                v-model="id"
                                                placeholder="Titulo"
                                                disabled
                                            />
                                        </div>
                                    </span>
                                    <span>
                                        <div class="form-group col">
                                            <label for="slug"
                                                >Slug
                                                <span class="text-danger"
                                                    >*</span
                                                ></label
                                            >
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="slug"
                                                v-model="slug"
                                                placeholder="Titulo"
                                                disabled
                                            />
                                        </div>
                                    </span>
                                    <span>
                                        <div class="form-group col">
                                            <label for="name">Nombre</label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="name"
                                                v-model="name"
                                            />
                                        </div>
                                    </span>
                                    <span>
                                        <div class="form-group col">
                                            <label for="version">Versión</label>
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="version"
                                                v-model="version"
                                                disabled
                                            />
                                        </div>
                                    </span>
                                </div>

                                <div class="row row-cols-1">
                                    <span>
                                        <div class="form-group col">
                                            <label for="countries"
                                                >Paises
                                                <span class="text-danger"
                                                    >*</span
                                                ></label
                                            >
                                            <multiselect
                                                v-model="countries"
                                                tag-placeholder="Add this as new tag"
                                                placeholder="Seleccione paises"
                                                label="name"
                                                track-by="id"
                                                :options="arrayCountries"
                                                :multiple="true"
                                                :taggable="true"
                                            ></multiselect>
                                        </div>
                                    </span>
                                    <span>
                                        <div class="form-group col">
                                            <label for="categories"
                                                >Categorias
                                                <span class="text-danger"
                                                    >*</span
                                                ></label
                                            >
                                            <multiselect
                                                v-model="categories"
                                                placeholder="Seleccione categorias"
                                                label="name"
                                                track-by="id"
                                                :options="arrayCategories"
                                                :multiple="true"
                                                :taggable="true"
                                            ></multiselect>
                                        </div>
                                    </span>
                                </div>

                                <div
                                    class="row row-cols-1 row-cols-md-1 row-cols-lg-3"
                                >
                                    <span>
                                        <div class="form-group col">
                                            <label for="admin_name"
                                                >Nombre administrador de
                                                concurso
                                                <span class="text-danger"
                                                    >*</span
                                                ></label
                                            >
                                            <input
                                                type="text"
                                                v-model="admin_name"
                                                class="form-control"
                                                placeholder="Nombre administrador"
                                            />
                                        </div>
                                    </span>
                                    <span>
                                        <div class="form-group col">
                                            <label for="admin_email"
                                                >Correo administrador
                                                <span class="text-danger"
                                                    >*</span
                                                ></label
                                            >
                                            <input
                                                type="email"
                                                v-model="admin_email"
                                                class="form-control"
                                                placeholder="Correo administrador"
                                            />
                                        </div>
                                    </span>
                                    <span>
                                        <div class="form-group col">
                                            <label for="password"
                                                >Contraseña administrador
                                                <span class="text-danger"
                                                    >*</span
                                                ></label
                                            >
                                            <input
                                                type="password"
                                                v-model="password"
                                                class="form-control"
                                                placeholder="Contraseña"
                                            />
                                        </div>
                                    </span>
                                </div>

                                <div
                                    v-if="status == 'publicado'"
                                    class="row row-cols-1 row-cols-md-1 row-cols-lg-3"
                                >
                                    <span>
                                        <div
                                            class="form-group col d-flex flex-column"
                                        >
                                            <label for="start_date_phase_1"
                                                >Fecha inicio fase 1
                                                <span class="text-danger"
                                                    >*</span
                                                ></label
                                            >
                                            <date-picker
                                                v-model="start_date_phase_1"
                                                type="date"
                                                valueType="format"
                                                :lang="lang"
                                                format="YYYY-MM-DD"
                                            ></date-picker>
                                        </div>
                                    </span>
                                    <span>
                                        <div
                                            class="form-group col d-flex flex-column"
                                        >
                                            <label for="start_date_phase_2"
                                                >Fecha inicio fase 2
                                                <span class="text-danger"
                                                    >*</span
                                                ></label
                                            >
                                            <date-picker
                                                v-model="start_date_phase_2"
                                                type="date"
                                                valueType="format"
                                                :lang="lang"
                                                format="YYYY-MM-DD"
                                            ></date-picker>
                                        </div>
                                    </span>
                                    <span>
                                        <div
                                            class="form-group col d-flex flex-column"
                                        >
                                            <label for="start_date_phase_3"
                                                >Fecha inicio fase 3
                                                <span class="text-danger"
                                                    >*</span
                                                ></label
                                            >
                                            <date-picker
                                                v-model="start_date_phase_3"
                                                type="date"
                                                valueType="format"
                                                :lang="lang"
                                                format="YYYY-MM-DD"
                                            ></date-picker>
                                        </div>
                                    </span>
                                </div>

                                <div
                                    v-if="status == 'publicado'"
                                    class="row row-cols-1 row-cols-md-1 row-cols-lg-3"
                                >
                                    <span>
                                        <div
                                            class="form-group col d-flex flex-column"
                                        >
                                            <label for="end_date_phase_1"
                                                >Fecha final fase 1
                                                <span class="text-danger"
                                                    >*</span
                                                ></label
                                            >
                                            <date-picker
                                                v-model="end_date_phase_1"
                                                type="date"
                                                valueType="format"
                                                :lang="lang"
                                                format="YYYY-MM-DD"
                                            ></date-picker>
                                        </div>
                                    </span>
                                    <span>
                                        <div
                                            class="form-group col d-flex flex-column"
                                        >
                                            <label for="end_date_phase_2"
                                                >Fecha final fase 2
                                                <span class="text-danger"
                                                    >*</span
                                                ></label
                                            >
                                            <date-picker
                                                v-model="end_date_phase_2"
                                                type="date"
                                                valueType="format"
                                                :lang="lang"
                                                format="YYYY-MM-DD"
                                            ></date-picker>
                                        </div>
                                    </span>
                                    <span>
                                        <div
                                            class="form-group col d-flex flex-column"
                                        >
                                            <label for="end_date_phase_3"
                                                >Fecha final fase 3
                                                <span class="text-danger"
                                                    >*</span
                                                ></label
                                            >
                                            <date-picker
                                                v-model="end_date_phase_3"
                                                type="date"
                                                valueType="format"
                                                :lang="lang"
                                                format="YYYY-MM-DD"
                                            ></date-picker>
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <div class="card">
                            <div class="card-header font-weight-bold">
                                Imagenes
                            </div>
                            <div class="card-body">
                                <div class="row row-cols-1 row-cols-md-2">
                                    <span>
                                        <div class="form-group col">
                                            <label for="image_path"
                                                >Imagen
                                                <a
                                                    v-if="image_path"
                                                    :href="image_path"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    >(Ver imagen)</a
                                                >
                                                <span class="text-danger"
                                                    >*</span
                                                ></label
                                            >
                                            <div
                                                id="fine-uploader-manual-trigger"
                                            ></div>
                                        </div>
                                    </span>

                                    <span>
                                        <div class="form-group col">
                                            <label for="image_webp_path"
                                                >Imagen webp
                                                <a
                                                    v-if="image_webp_path"
                                                    :href="image_webp_path"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    >(Ver imagen)</a
                                                >
                                                <span class="text-danger"
                                                    >*</span
                                                ></label
                                            >
                                            <div
                                                id="fine-uploader-manual-trigger-webp"
                                            ></div>
                                        </div>
                                    </span>

                                    <span>
                                        <div class="form-group col">
                                            <label for="image_dashboard"
                                                >Imagen dashboard
                                                <a
                                                    v-if="image_dashboard"
                                                    :href="image_dashboard"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    >(Ver imagen)</a
                                                >
                                                <span class="text-danger"
                                                    >*</span
                                                ></label
                                            >
                                            <div
                                                id="fine-uploader-manual-trigger-dashboard"
                                            ></div>
                                        </div>
                                    </span>

                                    <span>
                                        <div class="form-group col">
                                            <label for="image_dashboard"
                                                >Imagen dashboard webp
                                                <a
                                                    v-if="
                                                        image_dashboard_webp_path
                                                    "
                                                    :href="
                                                        image_dashboard_webp_path
                                                    "
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    >(Ver imagen)</a
                                                >
                                                <span class="text-danger"
                                                    >*</span
                                                ></label
                                            >
                                            <div
                                                id="fine-uploader-manual-trigger-dashboard-webp"
                                            ></div>
                                        </div>
                                    </span>

                                    <span>
                                        <div class="form-group col">
                                            <label for="base_pdf_path"
                                                >PDF bases concurso
                                                <a
                                                    v-if="base_pdf_path"
                                                    :href="base_pdf_path"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    >(Ver PDF)</a
                                                >
                                                <span class="text-danger"
                                                    >*</span
                                                ></label
                                            >
                                            <div
                                                id="fine-uploader-manual-trigger-pdf"
                                            ></div>
                                        </div>
                                    </span>

                                    <span>
                                        <div class="form-group col">
                                            <label for="judge_instructions_path"
                                                >PDF instrucciones jurado
                                                <a
                                                    v-if="
                                                        judge_instructions_path
                                                    "
                                                    :href="
                                                        judge_instructions_path
                                                    "
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    >(Ver archivo)</a
                                                >
                                                -
                                                <a
                                                    v-if="
                                                        judge_instructions_path
                                                    "
                                                    @click="delete_file"
                                                    href="#"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    >Eliminar</a
                                                >
                                                <span class="text-danger"
                                                    >*</span
                                                ></label
                                            >
                                            <div
                                                id="fine-uploader-manual-trigger-instructions-file"
                                            ></div>
                                        </div>
                                    </span>

                                    <span>
                                        <div class="form-group col">
                                            <label for="title"
                                                >Alt image
                                                <span class="text-danger"
                                                    >*</span
                                                ></label
                                            >
                                            <input
                                                type="text"
                                                v-model="text_image_alt"
                                                class="form-control"
                                                placeholder="Alt image"
                                            />
                                        </div>
                                    </span>

                                    <span>
                                        <div class="form-group col">
                                            <label for="alt_image_dashboard"
                                                >Alt image dashboard
                                                <span class="text-danger"
                                                    >*</span
                                                ></label
                                            >
                                            <input
                                                type="text"
                                                v-model="alt_image_dashboard"
                                                class="form-control"
                                                placeholder="Alt image"
                                            />
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row row-cols-1 row-cols-md-2">
                    <div class="col-sm-6">
                        <div class="card">
                            <div class="card-header font-weight-bold">
                                Configuraciones adicionales
                            </div>
                            <div class="card-body">
                                <div class="px-3 flex-col">
                                    <span>
                                        <div
                                            class="custom-control custom-switch"
                                        >
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                id="show_finalists"
                                                value="show_finalists"
                                                v-model="show_finalists"
                                                :checked="show_finalists"
                                            />
                                            <label
                                                class="custom-control-label"
                                                for="show_finalists"
                                                >Mostrar finalistas</label
                                            >
                                        </div>
                                    </span>
                                    <span>
                                        <div
                                            class="custom-control custom-switch"
                                        >
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                id="show_faqs"
                                                value="show_faqs"
                                                v-model="show_faqs"
                                                :checked="show_faqs"
                                            />
                                            <label
                                                class="custom-control-label"
                                                for="show_faqs"
                                                >Mostrar P. Frecuentes</label
                                            >
                                        </div>
                                    </span>
                                    <span>
                                        <div
                                            class="custom-control custom-switch"
                                        >
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                id="show_allies"
                                                value="show_allies"
                                                v-model="show_allies"
                                                :checked="show_allies"
                                            />
                                            <label
                                                class="custom-control-label"
                                                for="show_allies"
                                                >Mostrar aliados</label
                                            >
                                        </div>
                                    </span>
                                    <span>
                                        <div
                                            class="custom-control custom-switch"
                                        >
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                id="show_winners"
                                                value="show_winners"
                                                v-model="show_winners"
                                                :checked="show_winners"
                                            />
                                            <label
                                                class="custom-control-label"
                                                for="show_winners"
                                                >Mostrar sección
                                                ganadores</label
                                            >
                                        </div>
                                    </span>
                                    <span>
                                        <div
                                            class="custom-control custom-switch"
                                        >
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                id="show_winners_page"
                                                value="show_winners_page"
                                                v-model="show_winners_page"
                                                :checked="show_winners_page"
                                            />
                                            <label
                                                class="custom-control-label"
                                                for="show_winners_page"
                                                >Mostrar página ganadores</label
                                            >
                                        </div>
                                    </span>
                                    <span>
                                        <div
                                            class="custom-control custom-switch"
                                        >
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                id="show_judges"
                                                value="show_judges"
                                                v-model="show_judges"
                                                :checked="show_judges"
                                            />
                                            <label
                                                class="custom-control-label"
                                                for="show_judges"
                                                >Mostrar jurados</label
                                            >
                                        </div>
                                    </span>
                                    <span>
                                        <div
                                            class="custom-control custom-switch"
                                        >
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                id="show_inscription"
                                                value="show_inscription"
                                                v-model="show_inscription"
                                                :checked="show_inscription"
                                            />
                                            <label
                                                class="custom-control-label"
                                                for="show_inscription"
                                                >Permitir inscripción de
                                                proyectos</label
                                            >
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="card">
                            <div class="card-header">
                                <h6 class="font-weight-bold">
                                    Parametros especiales
                                </h6>
                                <p class="m-0 text-danger">
                                    Advertencia: Use estas opciones para casos
                                    muy especiales, estas podrian afectar el
                                    correcto funcionamiento del concurso
                                </p>
                            </div>
                            <div class="card-body">
                                <div class="px-3 flex-col">
                                    <span>
                                        <div
                                            class="custom-control custom-switch"
                                        >
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                id="is_visible"
                                                value="is_visible"
                                                v-model="is_visible"
                                                :checked="is_visible"
                                            />
                                            <label
                                                class="custom-control-label"
                                                for="is_visible"
                                                >Mostrar concurso en
                                                socialskin</label
                                            >
                                        </div>
                                    </span>
                                    <span>
                                        <div
                                            class="custom-control custom-switch"
                                        >
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                id="is_start_revision"
                                                value="is_start_revision"
                                                v-model="is_start_revision"
                                                :checked="is_start_revision"
                                            />
                                            <label
                                                class="custom-control-label"
                                                for="is_start_revision"
                                                >Iniciar etapa de
                                                revisión</label
                                            >
                                        </div>
                                    </span>
                                    <span>
                                        <div
                                            class="custom-control custom-switch"
                                        >
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                id="is_start_phase_1"
                                                value="is_start_phase_1"
                                                v-model="is_start_phase_1"
                                                :checked="is_start_phase_1"
                                            />
                                            <label
                                                class="custom-control-label"
                                                for="is_start_phase_1"
                                                >Iniciar fase 1</label
                                            >
                                        </div>
                                    </span>
                                    <span>
                                        <div
                                            class="custom-control custom-switch"
                                        >
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                id="is_start_phase_2"
                                                value="is_start_phase_2"
                                                v-model="is_start_phase_2"
                                                :checked="is_start_phase_2"
                                            />
                                            <label
                                                class="custom-control-label"
                                                for="is_start_phase_2"
                                                >Iniciar fase 2</label
                                            >
                                        </div>
                                    </span>
                                    <span>
                                        <div
                                            class="custom-control custom-switch"
                                        >
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                id="is_start_phase_3"
                                                value="is_start_phase_3"
                                                v-model="is_start_phase_3"
                                                :checked="is_start_phase_3"
                                            />
                                            <label
                                                class="custom-control-label"
                                                for="is_start_phase_3"
                                                >Iniciar fase 3</label
                                            >
                                        </div>
                                    </span>
                                    <span>
                                        <div
                                            class="custom-control custom-switch"
                                        >
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                id="is_finalized_phase_1"
                                                value="is_finalized_phase_1"
                                                v-model="is_finalized_phase_1"
                                                :checked="is_finalized_phase_1"
                                            />
                                            <label
                                                class="custom-control-label"
                                                for="is_finalized_phase_1"
                                                >Finalizar fase 1</label
                                            >
                                        </div>
                                    </span>
                                    <span>
                                        <div
                                            class="custom-control custom-switch"
                                        >
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                id="is_finalized_phase_2"
                                                value="is_finalized_phase_2"
                                                v-model="is_finalized_phase_2"
                                                :checked="is_finalized_phase_2"
                                            />
                                            <label
                                                class="custom-control-label"
                                                for="is_finalized_phase_2"
                                                >Finalizar fase 2</label
                                            >
                                        </div>
                                    </span>
                                    <span>
                                        <div
                                            class="custom-control custom-switch"
                                        >
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                id="is_finalized_phase_3"
                                                value="is_finalized_phase_3"
                                                v-model="is_finalized_phase_3"
                                                :checked="is_finalized_phase_3"
                                            />
                                            <label
                                                class="custom-control-label"
                                                for="is_finalized_phase_3"
                                                >Finalizar fase 3</label
                                            >
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button
                        v-if="can_clone"
                        type="button"
                        data-toggle="modal"
                        data-target="#exampleModal"
                        class="btn btn-success mr-auto"
                    >
                        Clonar
                    </button>
                    <button
                        v-if="showVisible"
                        type="button"
                        @click="toggleVisible()"
                        class="btn btn-primary"
                    >
                        Mostrar en la pagina
                    </button>
                    <button
                        v-if="showHidden"
                        type="button"
                        @click="toggleVisible()"
                        class="btn btn-primary"
                    >
                        Ocultar en la pagina
                    </button>
                    <button
                        v-if="showRevision"
                        type="button"
                        @click="revision()"
                        class="btn btn-primary"
                    >
                        Iniciar fase revisión
                    </button>
                    <button
                        v-if="showStartPhase1"
                        type="button"
                        @click="updatePhase(1)"
                        class="btn btn-primary"
                    >
                        Finalizar revisión e iniciar fase 1
                    </button>
                    <button
                        v-if="showEndPhase1"
                        type="button"
                        @click="updatePhase(2)"
                        class="btn btn-primary"
                    >
                        Finalizar fase 1
                    </button>
                    <button
                        v-if="showStartPhase2"
                        type="button"
                        @click="updatePhase(3)"
                        class="btn btn-primary"
                    >
                        Iniciar fase 2
                    </button>
                    <button
                        v-if="showEndPhase2"
                        type="button"
                        @click="updatePhase(4)"
                        class="btn btn-primary"
                    >
                        Finalizar fase 2
                    </button>
                    <button
                        v-if="showStartPhase3"
                        type="button"
                        @click="updatePhase(5)"
                        class="btn btn-primary"
                    >
                        Iniciar fase 3
                    </button>
                    <button
                        v-if="showEndPhase3"
                        type="button"
                        @click="updatePhase(6)"
                        class="btn btn-primary"
                    >
                        Finalizar fase 3
                    </button>

                    <button
                        v-if="showRequestApproval"
                        type="button"
                        @click="updateStatus('status-request-approval')"
                        class="btn btn-primary"
                    >
                        Solicitar aprobacion
                    </button>
                    <button
                        v-if="showApproval"
                        type="button"
                        @click="updateStatus('status-approval')"
                        class="btn btn-primary"
                    >
                        Aprobar propuesta de premio
                    </button>
                    <button
                        v-if="showReject"
                        type="button"
                        @click="updateStatus('status-reject')"
                        class="btn btn-primary"
                    >
                        Rechazar propuesta de premio
                    </button>
                    <button
                        v-if="showPublish"
                        type="button"
                        @click="updateStatus('status-publish')"
                        class="btn btn-primary"
                    >
                        Publicar premio
                    </button>
                    <button
                        v-if="showFinalize"
                        type="button"
                        @click="updateStatus('status-finalize')"
                        class="btn btn-primary"
                    >
                        Finalizar premio
                    </button>
                    <button
                        v-if="showUpdate"
                        type="button"
                        @click="update()"
                        class="btn btn-primary"
                    >
                        Actualizar
                    </button>
                </div>
            </div>
        </form>

        <template-uploader></template-uploader>
        <template-uploader
            template_id="qq-template-manual-trigger-webp"
            text_button="Imagen webp"
        ></template-uploader>
        <template-uploader
            template_id="qq-template-manual-trigger-dashboard"
            text_button="Imagen dashboard"
        ></template-uploader>
        <template-uploader
            template_id="qq-template-manual-trigger-dashboard-webp"
            text_button="Imagen dashboard-webp"
        ></template-uploader>
        <template-uploader
            template_id="qq-template-manual-trigger-pdf"
            text_button="Pdf"
        ></template-uploader>
        <template-uploader
            template_id="qq-template-manual-trigger-instructions-file"
            text_button="Archivo"
        ></template-uploader>
    </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { _ } from "vue-underscore";
import qq from "fine-uploader";
import "fine-uploader/fine-uploader/fine-uploader-new.min.css";
import helpers from "../../mixins/index";

export default {
    mixins: [helpers],
    props: {
        model_id: Number,
    },
    data() {
        return {
            is_visible: false,
            is_start_revision: false,
            is_finalized_phase_1: false,
            is_finalized_phase_2: false,
            is_finalized_phase_3: false,
            visible: false,
            confirmLoading: false,
            model_full: null,
            start_date_phase_1: null,
            end_date_phase_1: null,
            start_date_phase_2: null,
            end_date_phase_2: null,
            start_date_phase_3: null,
            end_date_phase_3: null,
            id: null,
            slug: "",
            name: "",
            version: "",
            status: null,
            is_active_phase: false,
            is_start_phase_1: false,
            is_start_phase_2: false,
            is_start_phase_3: false,
            admin_name: null,
            user_admin_id: null,
            admin_email: null,
            password: null,
            announcement: "",
            summary: "",
            image: "",
            image_webp: "",
            text_image_alt: "",
            base_pdf: "",
            judge_instructions: "",
            image_path: "",
            image_webp_path: "",
            base_pdf_path: "",
            judge_instructions_path: "",
            countries: [],
            arrayCountries: [],
            categories: [],
            arrayCategories: [],
            arrayContestAnts: [],
            showApproval: false,
            showFinalize: false,
            showPublish: false,
            showReject: false,
            showRequestApproval: false,
            showVisible: false,
            showRevision: false,
            showHidden: false,
            showUpdate: false,
            showFieldInscription: false,
            show_finalists: false,
            show_winners: false,
            show_winners_page: false,
            show_allies: false,
            show_judges: false,
            show_faqs: false,
            show_inscription: false,
            showStartPhase1: false,
            showEndPhase1: false,
            showStartPhase2: false,
            showEndPhase2: false,
            showStartPhase3: false,
            showEndPhase3: false,
            alt_image_dashboard: null,
            image_dashboard: null,
            image_dashboard_webp: null,
            image_dashboard_path: null,
            image_dashboard_webp_path: null,
            can_clone: null,
            new_name: null,
            allerrors: {
                announcement: null,
                admin_name: null,
                admin_email: null,
                password: null,
                summary: null,
                image: null,
                image_webp: null,
                text_image_alt: null,
                base_pdf: null,
                judge_instructions: null,
                start_date_phase_1: null,
                end_date_phase_1: null,
                start_date_phase_2: null,
                end_date_phase_2: null,
                start_date_phase_3: null,
                end_date_phase_3: null,
                is_active_phase: null,
                alt_image_dashboard: null,
                image_dashboard: null,
                image_dashboard_webp: null,
                new_name: null,
            },
            lang: {
                days: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
                months: [
                    "Ene",
                    "Feb",
                    "Mar",
                    "Abr",
                    "May",
                    "Jun",
                    "Jul",
                    "Ago",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dic",
                ],
                pickers: [
                    "next 7 days",
                    "next 30 days",
                    "previous 7 days",
                    "previous 30 days",
                ],
                placeholder: {
                    date: "Seleccione fecha",
                },
            },
            editor: ClassicEditor,
            editorConfig: {
                toolbar: ["bold", "italic", "underline"],
            },
            appUrl: document.querySelector('meta[name="app-url"]').content,
        };
    },
    methods: {
        getContest() {
            let me = this;
            axios
                .get("/api/contests/basic?contest_id=" + me.model_id)
                .then(function (response) {
                    const { data } = response.data;
                    me.id = data.contest.id;
                    me.slug = data.contest.slug;
                    me.name = data.contest.name;
                    me.version = data.contest.version;
                    me.summary = data.contest.summary;
                    me.base_pdf = data.contest.base_pdf;
                    me.judge_instructions = data.contest.judge_instructions;
                    me.text_image_alt = data.contest.text_image_alt;
                    me.announcement = data.contest.announcement;
                    me.show_finalists = data.contest.show_finalists;
                    me.show_winners = data.contest.show_winners;
                    me.show_winners_page = data.contest.show_winners_page;
                    me.show_faqs = data.contest.show_faqs;
                    me.show_judges = data.contest.show_judges;
                    me.show_allies = data.contest.show_allies;
                    me.show_inscription = data.contest.show_inscription;
                    me.countries = data.countries;
                    me.categories = data.categories;
                    me.image = data.contest.image;
                    me.image_webp = data.contest.image_webp;
                    me.showApproval = data.showApproval;
                    me.showFinalize = data.showFinalize;
                    me.showPublish = data.showPublish;
                    me.showReject = data.showReject;
                    me.showRequestApproval = data.showRequestApproval;
                    me.showUpdate = data.showUpdate;
                    me.showVisible = data.showVisible;
                    me.showRevision = data.showRevision;
                    me.showHidden = data.showHidden;
                    me.showFieldInscription = data.showFieldInscription;
                    me.base_pdf_path = data.base_pdf_path;
                    me.judge_instructions_path = data.judge_instructions_path;
                    me.image_path = data.image_path;
                    me.image_webp_path = data.image_webp_path;
                    me.admin_name = data.admin_name;
                    me.admin_email = data.admin_email;
                    me.user_admin_id = data.contest.user_admin_id;
                    me.start_date_phase_1 = data.start_date_phase_1;
                    me.end_date_phase_1 = data.end_date_phase_1;
                    me.start_date_phase_2 = data.start_date_phase_2;
                    me.end_date_phase_2 = data.end_date_phase_2;
                    me.start_date_phase_3 = data.start_date_phase_3;
                    me.end_date_phase_3 = data.end_date_phase_3;
                    me.is_active_phase = data.is_active_phase;
                    me.status = data.status;
                    me.image_dashboard_path = data.image_dashboard_path;
                    me.image_dashboard_webp_path =
                        data.image_dashboard_webp_path;
                    me.image_dashboard_webp = data.contest.image_dashboard_webp;
                    me.image_dashboard = data.contest.image_dashboard;
                    me.alt_image_dashboard = data.contest.alt_image_dashboard;
                    me.showStartPhase1 = data.showStartPhase1;
                    me.showEndPhase1 = data.showEndPhase1;
                    me.showStartPhase2 = data.showStartPhase2;
                    me.showEndPhase2 = data.showEndPhase2;
                    me.showStartPhase3 = data.showStartPhase3;
                    me.showEndPhase3 = data.showEndPhase3;
                    me.model_full = data.contest;
                    me.can_clone = data.can_clone ? data.can_clone : null;
                    me.is_visible = data.contest.is_visible;
                    me.is_start_revision = data.contest.is_start_revision;
                    me.is_start_phase_1 = data.contest.is_start_phase_1;
                    me.is_start_phase_2 = data.contest.is_start_phase_2;
                    me.is_start_phase_3 = data.contest.is_start_phase_3;
                    me.is_finalized_phase_1 = data.contest.is_finalized_phase_1;
                    me.is_finalized_phase_2 = data.contest.is_finalized_phase_2;
                    me.is_finalized_phase_3 = data.contest.is_finalized_phase_3;

                    me.clearError();
                    me.$store.commit('setContest', data.contest);
                })
                .catch(function (error) {
                    console.error(error);
                });
        },
        getListCountries() {
            let me = this;
            axios
                .get("/api/contests/countries")
                .then(function (response) {
                    me.arrayCountries = response.data;
                })
                .catch(function (error) {
                    console.error(error);
                });
        },
        getListCategories() {
            let me = this;
            axios
                .get("/api/categories?paginate=false")
                .then(function (response) {
                    me.arrayCategories = response.data;
                })
                .catch(function (error) {
                    console.error(error);
                });
        },
        update() {
            let me = this;

            me.loading();

            if (me.validForm()) {
                axios
                    .put("/admin/contest/basic/" + me.model_id, {
                        slug: me.slug,
                        summary: me.summary,
                        announcement: me.announcement,
                        countries: _.pluck(me.countries, "id"),
                        categories: _.pluck(me.categories, "id"),
                        image: me.image,
                        image_webp: me.image_webp,
                        base_pdf: me.base_pdf,
                        judge_instructions: me.judge_instructions,
                        text_image_alt: me.text_image_alt,
                        show_finalists: me.show_finalists,
                        show_faqs: me.show_faqs,
                        show_allies: me.show_allies,
                        show_judges: me.show_judges,
                        show_winners: me.show_winners,
                        show_winners_page: me.show_winners_page,
                        show_inscription: me.show_inscription,
                        admin_name: me.admin_name,
                        admin_email: me.admin_email,
                        password: me.password,
                        start_date_phase_1: me.start_date_phase_1,
                        end_date_phase_1: me.end_date_phase_1,
                        start_date_phase_2: me.start_date_phase_2,
                        end_date_phase_2: me.end_date_phase_2,
                        start_date_phase_3: me.start_date_phase_3,
                        end_date_phase_3: me.end_date_phase_3,
                        image_dashboard: me.image_dashboard,
                        image_dashboard_webp: me.image_dashboard_webp,
                        alt_image_dashboard: me.alt_image_dashboard,

                        is_visible: me.is_visible,
                        is_start_revision: me.is_start_revision ?? false,
                        is_start_phase_1: me.is_start_phase_1,
                        is_start_phase_2: me.is_start_phase_2,
                        is_start_phase_3: me.is_start_phase_3,
                        is_finalized_phase_1: me.is_finalized_phase_1,
                        is_finalized_phase_2: me.is_finalized_phase_2,
                        is_finalized_phase_3: me.is_finalized_phase_3,
                    })
                    .then(function (response) {
                        me.closeLoading();
                        me.password = null;
                        me.user_admin_id = response.data.contest.user_admin_id;
                        me.base_pdf = response.data.contest.base_pdf;
                        me.judge_instructions =
                            response.data.contest.judge_instructions;
                        me.image_path = response.data.image_path;
                        me.image_webp_path = response.data.image_webp_path;
                        me.image_dashboard_path =
                            response.data.image_dashboard_path;
                        me.image_dashboard_webp_path =
                            response.data.image_dashboard_webp_path;
                        me.base_pdf_path = response.data.base_pdf_path;
                        me.judge_instructions_path =
                            response.data.judge_instructions_path;
                        me.model_full = response.data.contest;
                        me.start_date_phase_1 =
                            response.data.contest.start_date_phase_1;
                        me.end_date_phase_1 =
                            response.data.contest.end_date_phase_1;
                        me.start_date_phase_2 =
                            response.data.contest.start_date_phase_2;
                        me.end_date_phase_2 =
                            response.data.contest.end_date_phase_2;
                        me.start_date_phase_3 =
                            response.data.contest.start_date_phase_3;
                        me.end_date_phase_3 =
                            response.data.contest.end_date_phase_3;
                        me.clearError();
                        me.showActionSuccess("Actualizacion exitosa!");
                    })
                    .catch(function (error) {
                        let content = "";

                        if (error.response.status === 422) {
                            if (
                                typeof error.response?.data?.errors === "string"
                            ) {
                                content = error.response?.data?.errors;
                            } else {
                                const errors = Object.values(
                                    error.response?.data?.errors
                                );
                                content = errors
                                    .map((item) => `<li>${item}</li>`)
                                    .join("");
                            }
                            me.showSwalError(`<ul>${content}</ul>`);
                        } else {
                            me.showSwalError(
                                "No fue posible procesar su solicitud, intente mas tarde."
                            );
                        }
                    });
            }
        },
        revision() {
            let me = this;
            this.$swal({
                title: "Esta seguro que quiere iniciar fase de revisión?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                cancelButtonText: "Cancelar",
                confirmButtonText: "Si!",
            }).then((result) => {
                if (result.value) {
                    me.confirmLoading = true;
                    axios
                        .put("/admin/contest/revision/" + me.model_id)
                        .then(function (response) {
                            me.showRevision = response.data.showRevision;
                            me.showStartPhase1 = true;
                            me.showActionSuccess(
                                "La fase de revisión fue activada!"
                            );
                        })
                        .catch(function (error) {});
                }
            });
        },
        clone() {
            let me = this;
            this.$swal({
                title: "Esta seguro que quiere  este concurso?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                cancelButtonText: "Cancelar",
                confirmButtonText: "Si!",
            }).then((result) => {
                if (result.value) {
                    me.confirmLoading = true;
                    axios
                        .put("/admin/contest/clone/" + me.model_id, {
                            new_name: this.new_name,
                        })
                        .then(function (response) {
                            me.clearError();
                            me.confirmLoading = false;
                            me.showActionSuccess("Concurso clonado!");
                            me.closeModal();
                        })
                        .catch(function (error) {
                            if (error.response && error.response.data) {
                                me.confirmLoading = false;
                                me.allerrors = error.response.data.errors;
                            }
                        });
                }
            });
        },
        updateStatus(status) {
            let me = this;

            this.$swal({
                title: "Esta seguro?",
                text: "No podra revertir este cambio!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                cancelButtonText: "Cancelar",
                confirmButtonText: "Si!",
            }).then((result) => {
                if (result.value) {
                    axios
                        .put("/admin/contest/" + status + "/" + me.model_id)
                        .then(function (response) {
                            me.showApproval = response.data.showApproval;
                            me.showFinalize = response.data.showFinalize;
                            me.showPublish = response.data.showPublish;
                            me.showReject = response.data.showReject;
                            me.showRequestApproval =
                                response.data.showRequestApproval;
                            me.showUpdate = response.data.showUpdate;
                            me.showVisible = response.data.showVisible;
                            me.showHidden = response.data.showHidden;
                            me.showInscription = response.data.showInscription;
                            me.showFieldInscription =
                                response.data.showFieldInscription;
                            me.is_start_phase_1 = false;
                            me.is_start_phase_2 = false;
                            me.is_start_phase_3 = false;
                            me.showActionSuccess(
                                "Actualizacion de estado exitosa!"
                            );
                        })
                        .catch(function (error) {});
                }
            });
        },
        updatePhase(type) {
            let me = this;
            this.$swal({
                title: "Esta seguro?",
                text: "No podra revertir este cambio!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                cancelButtonText: "Cancelar",
                confirmButtonText: "Si!",
            }).then((result) => {
                if (result.value) {
                    let valid = true;
                    switch (type) {
                        case 1:
                            if (
                                !me.model_full.start_date_phase_1 ||
                                !me.model_full.end_date_phase_1
                            ) {
                                valid = false;
                            }

                            break;
                        case 3:
                            if (
                                !me.model_full.start_date_phase_2 ||
                                !me.model_full.end_date_phase_2
                            ) {
                                valid = false;
                            }
                            break;
                        case 5:
                            if (
                                !me.model_full.start_date_phase_3 ||
                                !me.model_full.end_date_phase_3
                            ) {
                                valid = false;
                            }
                            break;
                        default:
                            break;
                    }

                    if (valid) {
                        axios
                            .put("/admin/contest/update-phase/" + me.model_id, {
                                type: type,
                            })
                            .then(function (response) {
                                me.showInscription = false;
                                me.showFieldInscription = false;
                                me.showStartPhase1 =
                                    response.data.showStartPhase1;
                                me.showEndPhase1 = response.data.showEndPhase1;
                                me.showStartPhase2 =
                                    response.data.showStartPhase2;
                                me.showEndPhase2 = response.data.showEndPhase2;
                                me.showStartPhase3 =
                                    response.data.showStartPhase3;
                                me.showEndPhase3 = response.data.showEndPhase3;
                                me.is_start_phase_1 =
                                    response.data.is_start_phase_1;
                                me.is_start_phase_2 =
                                    response.data.is_start_phase_2;
                                me.is_start_phase_3 =
                                    response.data.is_start_phase_3;
                                me.showActionSuccess(
                                    "Actualizacion de estado exitosa!"
                                );
                            })
                            .catch(function (error) {});
                    }
                }
            });
        },
        activePhase() {
            let me = this;
            me.is_active_phase = true ? false : true;
        },
        closeModal(modal) {
            let me = this;
            $("#exampleModal").modal("hide");
            me.new_name = null;
        },
        toggleVisible() {
            let me = this;
            axios
                .put("/admin/contest/toggle-visible/" + me.model_id)
                .then(function (response) {
                    me.showVisible = response.data.showVisible;
                    me.showHidden = response.data.showHidden;
                    me.showActionSuccess("Actualizacion de estado exitosa!");
                })
                .catch(function (error) {});
        },
        validForm() {
            let me = this;
            let valid = true;

            if (!me.summary) {
                me.allerrors.summary = ["El campo resumen es obligatorio."];
                valid = false;
            } else if (me.summary.length > 300) {
                me.allerrors.summary = [
                    "El campo resumen debe tener máximo 300 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.summary = null;
            }

            if (!me.announcement) {
                me.allerrors.announcement = [
                    "El campo tecto convocatoria es obligatorio.",
                ];
                valid = false;
            } else if (me.announcement.length > 300) {
                me.allerrors.announcement = [
                    "El campo tecto convocatoria debe tener máximo 300 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.announcement = null;
            }

            if (!me.image) {
                me.allerrors.image = ["El campo imagen es obligatorio."];
                valid = false;
            }

            if (me.text_image_alt && me.text_image_alt.length > 190) {
                me.allerrors.text_image_alt = [
                    "El campo image alt debe tener máximo 190 caracteres",
                ];
                valid = false;
            } else {
                me.allerrors.text_image_alt = null;
            }

            if (!me.user_admin_id && !me.password) {
                me.allerrors.password = [
                    "El campo contrasena no debe ser vacio",
                ];
                valid = false;
            } else {
                me.allerrors.password = null;
            }
            if (!me.admin_email) {
                me.allerrors.admin_email = [
                    "El campo correo no debe ser vacio",
                ];
                valid = false;
            } else {
                me.allerrors.admin_email = null;
            }
            if (!me.admin_name) {
                me.allerrors.admin_name = ["El campo nombre no debe ser vacio"];
                valid = false;
            } else {
                me.allerrors.admin_name = null;
            }

            if (!me.start_date_phase_1 && me.end_date_phase_1) {
                me.allerrors.start_date_phase_1 = [
                    "La fecha inicial de la fase es obligatoría.",
                ];
                valid = false;
            } else {
                me.allerrors.start_date_phase_1 = null;
            }

            if (me.start_date_phase_1 && !me.end_date_phase_1) {
                me.allerrors.end_date_phase_1 = [
                    "La fecha final de la fase es obligatoría.",
                ];
                valid = false;
            } else {
                me.allerrors.end_date_phase_1 = null;
            }

            if (!me.start_date_phase_2 && me.end_date_phase_2) {
                me.allerrors.start_date_phase_2 = [
                    "La fecha inicial de la fase es obligatoría.",
                ];
                valid = false;
            } else {
                me.allerrors.start_date_phase_2 = null;
            }

            if (me.start_date_phase_2 && !me.end_date_phase_2) {
                me.allerrors.end_date_phase_2 = [
                    "La fecha final de la fase es obligatoría.",
                ];
                valid = false;
            } else {
                me.allerrors.end_date_phase_2 = null;
            }

            if (!me.start_date_phase_3 && me.end_date_phase_3) {
                me.allerrors.start_date_phase_3 = [
                    "La fecha inicial de la fase es obligatoría.",
                ];
                valid = false;
            } else {
                me.allerrors.start_date_phase_3 = null;
            }

            if (me.start_date_phase_3 && !me.end_date_phase_3) {
                me.allerrors.end_date_phase_3 = [
                    "La fecha final de la fase es obligatoría.",
                ];
                valid = false;
            } else {
                me.allerrors.end_date_phase_3 = null;
            }

            if (
                !me.start_date_phase_1 &&
                !me.end_date_phase_1 &&
                me.is_active_phase == true
            ) {
                me.allerrors.start_date_phase_1 = [
                    "No se puede actualizar sin tener las fechas de la fase 1.",
                ];
                valid = false;
            } else {
                me.allerrors.start_date_phase_1 = null;
            }

            return valid;
        },
        clearError() {
            let me = this;
            me.allerrors = {
                id: null,
                summary: null,
                image: null,
                image_webp: null,
                text_image_alt: null,
                base_pdf: null,
                judge_instructions: null,
                image_mobile: null,
                admin_name: null,
                admin_email: null,
                password: null,
                start_date_phase_1: null,
                end_date_phase_1: null,
                start_date_phase_2: null,
                end_date_phase_2: null,
                start_date_phase_3: null,
                end_date_phase_3: null,
                is_active_phase: null,
                alt_image_dashboard: null,
                image_dashboard: null,
                image_dashboard_webp: null,
            };
        },
        delete_file() {
            this.judge_instructions_path = null;
            this.judge_instructions = null;
        },
        showActionSuccess(message) {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
            });

            Toast.fire({
                type: "success",
                title: message,
            });
        },
        getUploadImageUrl() {
            const appUrl = document.querySelector(
                'meta[name="app-url"]'
            ).content;
            return `${appUrl}api/upload-image`;
        },
        getDeleteFileUrl() {
            const appUrl = document.querySelector(
                'meta[name="app-url"]'
            ).content;
            return `${appUrl}api/delete-file`;
        },
    },
    mounted() {
        let me = this;
        me.getListCountries();
        me.getListCategories();
        me.getContest();
        new qq.FineUploader({
            element: document.getElementById("fine-uploader-manual-trigger"),
            request: {
                endpoint: this.getUploadImageUrl(),
            },
            template: "qq-template-manual-trigger",
            validation: {
                allowedExtensions: ["jpeg", "jpg", "png", "svg"],
                sizeLimit: 20971520,
                image: {
                    maxHeight: 430,
                    minHeight: 430,
                    maxWidth: 1440,
                    minWidth: 1440,
                },
            },
            messages: {
                noFilesError: "Seleccione una imagen.",
                maxWidthImageError:
                    "Dimensiones incorrectas debe ser de 1440x430 px.",
                minWidthImageError:
                    "Dimensiones incorrectas debe ser de 1440x430 px.",
                maxHeightImageError:
                    "Dimensiones incorrectas debe ser de 1440x430 px.",
                minHeightImageError:
                    "Dimensiones incorrectas debe ser de 1440x430 px.",
            },
            callbacks: {
                onComplete: function (id, name, response) {
                    if (response.success) {
                        me.allerrors["image"] = null;
                        me.image = response.path;
                    } else {
                        me.allerrors["image"] = ["Error en la imagen"];
                    }
                },
            },
            multiple: false,
        });

        new qq.FineUploader({
            element: document.getElementById(
                "fine-uploader-manual-trigger-webp"
            ),
            request: {
                endpoint: this.getUploadImageUrl(),
            },
            template: "qq-template-manual-trigger-webp",
            validation: {
                allowedExtensions: ["webp"],
                sizeLimit: 20971520,
                image: {
                    maxHeight: 430,
                    minHeight: 430,
                    maxWidth: 1440,
                    minWidth: 1440,
                },
            },
            messages: {
                noFilesError: "Seleccione una imagen de tipo webp.",
                maxWidthImageError:
                    "Dimensiones incorrectas debe ser de 1440x430 px.",
                minWidthImageError:
                    "Dimensiones incorrectas debe ser de 1440x430 px.",
                maxHeightImageError:
                    "Dimensiones incorrectas debe ser de 1440x430 px.",
                minHeightImageError:
                    "Dimensiones incorrectas debe ser de 1440x430 px.",
            },
            callbacks: {
                onComplete: function (id, name, response) {
                    if (response.success) {
                        me.allerrors["image_webp"] = null;
                        me.image_webp = response.path;
                    } else {
                        me.allerrors["image_webp"] = ["Error en la imagen"];
                    }
                },
            },
            multiple: false,
        });

        new qq.FineUploader({
            element: document.getElementById(
                "fine-uploader-manual-trigger-dashboard"
            ),
            request: {
                endpoint: this.getUploadImageUrl(),
            },
            template: "qq-template-manual-trigger-dashboard",
            validation: {
                allowedExtensions: ["jpeg", "jpg", "png", "svg"],
                sizeLimit: 20971520,
            },
            messages: {
                noFilesError: "Seleccione una imagen.",
            },
            callbacks: {
                onComplete: function (id, name, response) {
                    if (response.success) {
                        me.allerrors["image_dashboard"] = null;
                        me.image_dashboard = response.path;
                    } else {
                        me.allerrors["image_dashboard"] = [
                            "Error en la imagen",
                        ];
                    }
                },
            },
            multiple: false,
        });
        new qq.FineUploader({
            element: document.getElementById(
                "fine-uploader-manual-trigger-dashboard-webp"
            ),
            request: {
                endpoint: this.getUploadImageUrl(),
            },
            template: "qq-template-manual-trigger-dashboard-webp",
            validation: {
                allowedExtensions: ["webp"],
                sizeLimit: 20971520,
            },
            messages: {
                noFilesError: "Seleccione una imagen de tipo webp.",
            },
            callbacks: {
                onComplete: function (id, name, response) {
                    if (response.success) {
                        me.allerrors["image_dashboard_webp"] = null;
                        me.image_dashboard_webp = response.path;
                    } else {
                        me.allerrors["image_dashboard_webp"] = [
                            "Error en la imagen",
                        ];
                    }
                },
            },
            multiple: false,
        });

        new qq.FineUploader({
            element: document.getElementById(
                "fine-uploader-manual-trigger-pdf"
            ),
            request: {
                endpoint: `${me.appUrl}api/upload-file`,
            },
            template: "qq-template-manual-trigger-pdf",
            validation: {
                allowedExtensions: ["pdf"],
                sizeLimit: 20971520,
            },
            messages: {
                noFilesError: "Seleccione un pdf.",
            },
            callbacks: {
                onComplete: function (id, name, response) {
                    if (response.success) {
                        me.allerrors["base_pdf"] = null;
                        me.base_pdf = response.path;
                    } else {
                        me.allerrors["base_pdf"] = ["Error en el pdf"];
                    }
                },
            },
            multiple: false,
        });

        new qq.FineUploader({
            element: document.getElementById(
                "fine-uploader-manual-trigger-instructions-file"
            ),
            request: {
                endpoint: `${me.appUrl}api/upload-instruction`,
            },
            template: "qq-template-manual-trigger-instructions-file",
            validation: {
                allowedExtensions: [
                    "pdf",
                    "jpeg",
                    "jpg",
                    "png",
                    "txt",
                    "xls",
                    "xlsx",
                ],
                sizeLimit: 20971520,
            },
            messages: {
                noFilesError: "Seleccione un archivo.",
            },
            callbacks: {
                onComplete: function (id, name, response) {
                    if (response.success) {
                        me.allerrors["judge_instructions"] = null;
                        me.judge_instructions = response.path;
                    } else {
                        me.allerrors["judge_instructions"] = [
                            "Error en el archivo",
                        ];
                    }
                },
            },
            multiple: false,
        });
    },
};
</script>
<style>
.mx-datepicker {
    width: 100%;
}

.mx-input {
    height: 36px;
}

.flex-col {
    display: flex;
    flex-direction: column;
    gap: 0.3em;
}

.show-error {
    display: block;
    margin-top: 0.25rem;
    font-size: 0.875rem;
    color: #f86c6b;
}
.centrado {
    display: flex;
    justify-content: center;
    align-items: center;
}
.lds-ring {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}
.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 64px;
    height: 64px;
    margin: 8px;
    border: 8px solid #fff;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: rgb(37, 133, 180) transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}
@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
